export * from './DepartmentAssessment';
